import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SnackbarWrapperComponent, SpinnerComponent } from '@dss-libs/shared/ui/common-components';
import { TranslocoService } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Directionality, Direction } from '@angular/cdk/bidi';

@Component({
  imports: [RouterModule, SnackbarWrapperComponent, SpinnerComponent],
  selector: 'dss-portal-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './app.component.css',
})
export class AppComponent {
  readonly #translationService = inject(TranslocoService);
  readonly #directionality = inject(Directionality);

  readonly setBodySubscription$ = this.#translationService.langChanges$.pipe(takeUntilDestroyed()).subscribe((lang) => {
    const dir: Direction = lang === 'ar' ? 'rtl' : 'ltr';
    document.body.dir = dir;
    this.#directionality.valueSignal.set(dir);
  });
}
